import api from '@/apis/di/currencyAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';
import {ref, watch, computed} from 'vue';
import commonFunction from '@/commons/commonFunction';
import store from '@/stores/store.js';
import { ModuleDbOption } from '@/stores/moduleConst.js';
// Combo Loại tiền
export const useCurrencyCombo = (
  comboboxDataRemote,
  comboboxLoadData,
  proxy,
  $grid,
  $gridParalell,
  $gridOther,
  customSelectCurrency,
  isNoCalcuTax = false  //HMDUC2 28/05/2024: Biến đánh dấu không tính thuế để không bị tính lại tiền thuế khi đã gán ở detail
) => {
  const {extendFilter} = usefilterActionCombo();

  const currencyCode = ref('VND');
  const isFirst = ref(true);

  // func call api lấy dữ liệu combo
  const onCurrencyComboboxLoadData = (payload, custom) => {
    payload.sort = 'currency_code';
    payload.columns += ',exchange_rate';
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [{Field: 'inactive', Value: false, Ors: ors}];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, 'currency', custom?.callBackFn);
  };

  /**
   * combo Loại tiền
   * NXCHIEN 17.05.2022
   */
  const selectCurrency = ({newData}) => {
    if (newData) {
      currencyCode.value = newData.currency_code;
      proxy.model.exchange_rate = newData.exchange_rate;
      // Gán lại giá trị tổng tiền khi chọn combo loại tiền
      proxy.model[$grid].forEach(x => {
        if (x.state != proxy.$ms.constant.ModelState.Empty) {
          x.amount = commonFunction?.roundDecimalDbOption(
            proxy?.$ms?.constant?.DbOptionKey?.CurrencyDecimalDigits,
            x.amount_oc * newData.exchange_rate,
          ) || x.amount_oc * newData.exchange_rate;

          x.to_amount = commonFunction?.roundDecimalDbOption(
            proxy?.$ms?.constant?.DbOptionKey?.CurrencyDecimalDigits,
            x.to_amount_oc * newData.exchange_rate,
          ) ||  x.to_amount_oc * newData.exchange_rate;

          x.remain_amount = commonFunction?.roundDecimalDbOption(
            proxy?.$ms?.constant?.DbOptionKey?.CurrencyDecimalDigits,
            x.remain_amount_oc * newData.exchange_rate,
          ) ||  x.remain_amount_oc * newData.exchange_rate;
        }
        if (x.state == proxy.$ms.constant.ModelState.None) {
          x.state = proxy.$ms.constant.ModelState.Update;
        }
      });
      proxy.model[$gridParalell]?.forEach(x => {
        if (x.state != proxy.$ms.constant.ModelState.Empty) {
          x.amount = commonFunction?.roundDecimalDbOption(
            proxy?.$ms?.constant?.DbOptionKey?.CurrencyDecimalDigits,
            x.amount_oc * newData.exchange_rate,
          ) || x.amount_oc * newData.exchange_rate;
        }
        if (x.state == proxy.$ms.constant.ModelState.None) {
          x.state = proxy.$ms.constant.ModelState.Update;
        }
      });
    } else {
      proxy.model.exchange_rate = 1;
      // tính tổng khi có thuế.
      proxy.model[$grid].forEach(x => {
        if (x.state != proxy.$ms.constant.ModelState.Empty) {
          x.amount = x.amount_oc;
          // x.to_amount = 0;
          // x.remain_amount = 0;
        }
        if (x.state == proxy.$ms.constant.ModelState.None) {
          x.state = proxy.$ms.constant.ModelState.Update;
        }
      });
      proxy.model[$gridParalell]?.forEach(x => {
        if (x.state != proxy.$ms.constant.ModelState.Empty) {
          x.amount = x.amount_oc;
        }
        if (x.state == proxy.$ms.constant.ModelState.None) {
          x.state = proxy.$ms.constant.ModelState.Update;
        }
      });
      proxy.model[$gridOther]?.forEach(x => {
        if (x.state != proxy.$ms.constant.ModelState.Empty) {
          x.amount = x.tax_amount;
        }
        if (x.state == proxy.$ms.constant.ModelState.None) {
          x.state = proxy.$ms.constant.ModelState.Update;
        }
      });
    }

    if (customSelectCurrency && typeof customSelectCurrency == 'function') {
      customSelectCurrency();
    }

    setTimeout(() => {
      proxy.$refs['refDetail']?.validate();
      proxy.$refs['refDetailOther']?.validate();
      proxy.$refs['refDetailParallel']?.validate();
    }, 500);
  };

  /**
   * blur ra khỏi ô combo loại tiền để lấy giá trị là VND khi xóa giá trị combo.
   * Modified by NVTUAN1: Push thêm giá trị VND vào mảng để pass validate forceSelection của combo
   */
  const assignValueCurrency = () => {
    if (proxy.$refs['refCurrencyCode']) {
      let value = proxy.$refs['refCurrencyCode'].validate();
      if (!proxy.model.currency_code || value) {
        proxy.$refs['refCurrencyCode'].internalText = proxy.$t('i18nEnum.Currency.VND');
        proxy.model.currency_code = proxy.$t('i18nEnum.Currency.VND');
        currencyCode.value = proxy.model.currency_code;

        //Check mảng chưa có loại tiền VND mới thêm
        if (
          Array.isArray(proxy.$refs['refCurrencyCode'].internalDataSource) &&
          !proxy.$refs['refCurrencyCode'].internalDataSource.find(x => x.currency_code === 'VND')
        ) {
          proxy.$refs['refCurrencyCode'].internalDataSource.push({
            currency_code: 'VND',
            currency_name: 'Việt Nam đồng',
            exchange_rate: 1,
          });
        }
      }

      setTimeout(() => {
        proxy.$refs['refCurrencyCode'].validate();
      }, 500);
    }
  };

  /**
   * Cập nhật Quy đổi tiền trong grid detail khi sửa lại hệ số Loại tiền và blur ra ngoài
   * @param {*} value
   * NXCHIEN 17.05.2022
   */
  const onActionBlur = value => {
    proxy.model[$grid].forEach(x => {
      if (x.state != proxy.$ms.constant.ModelState.Empty) {
        x.amount = commonFunction?.roundDecimalDbOption(
          proxy?.$ms?.constant?.DbOptionKey?.CurrencyDecimalDigits,
          x.amount_oc * value,
        ) || x.amount_oc * value;

        x.to_amount = commonFunction?.roundDecimalDbOption(
          proxy?.$ms?.constant?.DbOptionKey?.CurrencyDecimalDigits,
          x.to_amount_oc * value,
        ) || x.to_amount_oc * value;

        x.remain_amount = commonFunction?.roundDecimalDbOption(
          proxy?.$ms?.constant?.DbOptionKey?.CurrencyDecimalDigits,
          x.remain_amount_oc * value,
        ) || x.remain_amount_oc * value;
      }
      if (x.state == proxy.$ms.constant.ModelState.None) {
        x.state = proxy.$ms.constant.ModelState.Update;
      }
    });

    proxy.model[$gridParalell]?.forEach(x => {
      if (x.state != proxy.$ms.constant.ModelState.Empty) {
        x.amount = commonFunction?.roundDecimalDbOption(
          proxy?.$ms?.constant?.DbOptionKey?.CurrencyDecimalDigits,
          x.amount_oc * value,
        ) || x.amount_oc * value;
      }
      if (x.state == proxy.$ms.constant.ModelState.None) {
        x.state = proxy.$ms.constant.ModelState.Update;
      }
    });

    if (proxy.customActionBlur && typeof proxy.customActionBlur == 'function') {
      proxy.customActionBlur();
    }

    proxy.validateComponents();
  };

  /**
   * Loại tiền thay đổi thì load lại layout grid
   */
  watch(currencyCode, (newVal, oldVal) => {
    if (!isFirst.value) {
      if (newVal !== oldVal) {
        if (proxy.layoutTagDetail) {
          proxy.initLayoutDetail();
        }
        if (proxy.layoutTagDetailOther) {
          proxy.initLayoutDetailOther();
        }
      }
    }
  });

  /**
   * Tính lại số tiền Trường hợp có cả số tiền và quy đổi
   * NXCHIEN 22.07.2022
   */
  const totalAmountComputed = computed(() => {
    let keyModel = '';
    for (const key in proxy._gridDetails) {
      const element = proxy._gridDetails[key];
      if (element === 'refDetail') {
        keyModel = key;
      }
    }
    if (keyModel && proxy.model && Array.isArray(proxy.model[keyModel])) {
      let calcAmount = (sumField, field, account) => {
        let dataCalc =
          proxy.model[keyModel].filter(
            x =>
              x[sumField] &&
              x.state !== proxy.$ms.constant.ModelState.Delete &&
              x.state !== proxy.$ms.constant.ModelState.Empty,
          ) || [];
        if (account && dataCalc.length > 0) {
          dataCalc = dataCalc.filter(x => x[field] && x[field].startsWith(account));
        }

        return dataCalc.reduce((pre, cur) => {
          return pre + cur[sumField];
        }, 0);
      };

      let totalAmountOC = calcAmount('amount_oc');
      proxy.model.total_amount_oc = totalAmountOC;

      // tổng tiền
      let totalAmount = calcAmount('amount');
      proxy.model.total_amount = totalAmount;

      var totalPaymentAmount = 0;

      var totalReceiptAmount = 0;
      // NXCHIEN 25.11.2022: Tính lại tổng tiền ngoài danh sách theo điều kiện tài khoản
      switch (proxy.model.ref_type) {
        case proxy.$ms.constant.RefType.CAReceipt:
        case proxy.$ms.constant.RefType.CAReceiptSale:
        case proxy.$ms.constant.RefType.CAReceiptWithdraw:
        case proxy.$ms.constant.RefType.CAReceiptPlanWithdraw:
        case proxy.$ms.constant.RefType.CAReceiptCustomer:
          totalReceiptAmount = calcAmount('amount', 'debit_account', '111');
          break;
        case proxy.$ms.constant.RefType.CAPayment:
        //TODO Sau này sẽ bổ sung phiếu chi mua TSCĐ
        case proxy.$ms.constant.RefType.CAPaymentSalary:
        case proxy.$ms.constant.RefType.CAPaymentVendor:
          // không cộng tiền thuế ở tab thuế
          totalPaymentAmount = calcAmount('amount', 'credit_account', '111');
          break;
        case proxy.$ms.constant.RefType.CAPaymentDeposit:
          totalReceiptAmount = calcAmount('amount', 'debit_account', '112');
          totalPaymentAmount = calcAmount('amount', 'credit_account', '111');
          break;
        case proxy.$ms.constant.RefType.BAWithDraw:
        case proxy.$ms.constant.RefType.BAWithDrawFixedAsset:
        case proxy.$ms.constant.RefType.BAWithDrawSalary:
        case proxy.$ms.constant.RefType.BAWithdrawVendor:
          // không cộng tiền thuế ở tab thuế
          totalPaymentAmount = calcAmount('amount', 'credit_account', '112') ?? 0;
          totalReceiptAmount = calcAmount('amount', 'debit_account', '111');
          break;

        case proxy.$ms.constant.RefType.BADeposit:
        case proxy.$ms.constant.RefType.BADepositCustomer:
        case proxy.$ms.constant.RefType.BADepositSale:
          totalReceiptAmount = calcAmount('amount', 'debit_account', '112');
          break;
        case proxy.$ms.constant.RefType.FAVoucherDepreciate:
          proxy.model.total_amount = calcAmount('amount', 'credit_account', '214');
          break;
        case proxy.$ms.constant.RefType.BUTransferDeposit:
          totalReceiptAmount = calcAmount('amount', 'debit_account', '112');
          totalPaymentAmount = (proxy.model.total_amount ?? 0) + (proxy.model.total_tax_amount ?? 0);
          break;
        // Điều chuyển tài sản cố định
        case proxy.$ms.constant.RefType.FATransfer:
          totalAmount = calcAmount('org_price');
          proxy.model.total_org_price = totalAmount;
          break;
        default:
          totalReceiptAmount = proxy.model.total_amount;
          totalPaymentAmount = (proxy.model.total_amount ?? 0) + (proxy.model.total_tax_amount ?? 0);
          break;
      }
      proxy.model.total_payment_amount = totalPaymentAmount;
      proxy.model.total_receipt_amount = totalReceiptAmount;

      return totalAmount;
    }
    return 0;
  });

  /**
   * Tính tiền thuế
   * NXCHIEN 22.07.2022
   */
  const totalAmountReceiptComputed = computed(() => {
    let keyModel = '';
    let keyModelOther = '';
    for (const key in proxy._gridDetails) {
      const element = proxy._gridDetails[key];
      if (element === 'refDetail') {
        keyModel = key;
      }
      if (element === 'refDetailOther') {
        keyModelOther = key;
      }
    }
    if (keyModel && proxy.model && Array.isArray(proxy.model[keyModel])) {
      //Lấy ra tổng Số tiền tại tab hạch toán
      //TVDAT 28/07/2022
      let totalAmount = proxy.model[keyModel]
        .filter(x => x.amount && x.state !== proxy.$ms.constant.ModelState.Delete)
        .reduce((pre, cur) => {
          return pre + cur['amount'];
        }, 0);
      //Lấy ra tổng Số tiền tại tab thuế
      //TVDAT 28/07/2022
      let totalTaxAmount = proxy.model[keyModelOther]?.reduce((pre, cur) => {
        cur['tax_amount'] = cur['tax_amount'] ?? 0;
        pre = pre ?? 0;
        return pre + cur['tax_amount'];
      }, 0);

      proxy.model.total_amount = totalAmount;
      proxy.model.total_tax_amount = totalTaxAmount;
      //Gán tổng số tiền tại phần thông tin chung = tổng số tiền tại tab hạch toán + tổng số tiền tại tab thuế
      proxy.model.total_receipt_amount = (proxy.model.total_amount ?? 0) + (proxy.model.total_tax_amount ?? 0);
      return proxy.model.total_receipt_amount;
    }
    return 0;
  });

  /**
   * Tính tổng tiền dành cho chứng từ bán hàng
   * modified by NXCHIEN 28.11.2022: tính lại tổng tiền danh sách theo yêu cầu mới
   */
  const totalAmountInvoiceComputed = computed(() => {
    let keyModel = '';

    // HMDUC2: 28/05/2024: Biến đánh dấu PP trực tiếp
    let isDirectTaxMethod  = store.state[ModuleDbOption]?.dbOptions?.TaxCalculationMethod === proxy.$ms.constant.TaxCalculationMethod.DirectMethod;

    for (const key in proxy._gridDetails) {
      const element = proxy._gridDetails[key];
      if (element === 'refDetail') {
        keyModel = key;
      }
    }
    if (keyModel && proxy.model && Array.isArray(proxy.model[keyModel])) {
      let calcAmount = (sumField, field, account) => {
        let dataCalc =
          proxy.model[keyModel].filter(
            x =>
              x[sumField] &&
              x.state !== proxy.$ms.constant.ModelState.Delete &&
              x.state !== proxy.$ms.constant.ModelState.Empty,
          ) || [];
        if (account && dataCalc.length > 0) {
          dataCalc = dataCalc.filter(x => x[field] && x[field].startsWith(account));
        }

        return dataCalc.reduce((pre, cur) => {
          return pre + cur[sumField];
        }, 0);
      };

      //Lấy ra tổng Số tiền tại tab hạch toán
      let totalAmount = calcAmount('amount');

      //Lấy ra tổng Số tiền tại tab thuế
      let totalTaxAmount = calcAmount('tax_amount');

      //HMDUC2 28/05/2024: Nếu như ở màn hình detail hóa đơn và tính thuế PP trực tiếp thì tiền thuế được gán ở màn detail
      proxy.model.total_tax_amount = isNoCalcuTax ? proxy.model.total_tax_amount : keyModel ? totalTaxAmount : proxy.model.total_tax_amount;

      // Tính tiền giảm giá
      let totalDiscountAmount = calcAmount('discount_amount');
      // case trong trường hợp thu tiền gửi bán hàng thì lấy tổng số tiền theo TK nợ 112
      switch (proxy.model.ref_type) {
        case proxy.$ms.constant.RefType.BADepositSale:
          proxy.model.total_receipt_amount = calcAmount('amount', 'debit_account', '112');
          break;
      }

      proxy.model.total_outward_amount = totalAmount ?? 0;
      //HMDUC2 28/05/2024: Nếu như ở màn hình detail hóa đơn và tính thuế PP trực tiếp thì tiền thuế được gán ở màn detail
      proxy.model.total_tax_amount = isNoCalcuTax ? proxy.model.total_tax_amount : totalTaxAmount ?? 0;
      proxy.model.total_discount_amount = totalDiscountAmount ?? 0;
      // Tổng tiền ngoài danh sách
      proxy.model.total_list_amount = (totalAmount ?? 0) + (totalTaxAmount ?? 0) - (totalDiscountAmount ?? 0);

      if(isDirectTaxMethod && isNoCalcuTax){
        // HMDUC2 28/05/2024: Nếu tính thuế theo PP trực tiếp thì tổng tiền thanh toán = tổng tiền - tổng ck,giảm giá - tiền thuế được giảm
        proxy.model.total_amount = (totalAmount ?? 0) - (totalDiscountAmount ?? 0) - (totalTaxAmount ?? 0); 
      }else{
        proxy.model.total_amount = (totalAmount ?? 0) - (totalDiscountAmount ?? 0) + (totalTaxAmount ?? 0);
      }

      //Trả ra tổng số tiền tại phần thông tin chung = tổng số tiền tại tab hạch toán + tổng số tiền tại tab thuế - tổng tiền ck, giảm giá
      let result = (totalAmount ?? 0) + (totalTaxAmount ?? 0) - (totalDiscountAmount ?? 0);
      // HMDUC2: Nếu tính thuế PP trực tiếp thì tổng số tiền tại phần thông tin chung = tổng số tiền tại tab hạch toán - tổng số tiền tại tab thuế - tổng tiền ck, giảm giá
      if(isDirectTaxMethod && isNoCalcuTax){
        result =  (totalAmount ?? 0) - (totalTaxAmount ?? 0) - (totalDiscountAmount ?? 0);
      }
      
      return result
    }
    return 0;
  });

  return {
    onActionBlur,
    selectCurrency,
    onCurrencyComboboxLoadData,
    currencyCode,
    isFirst,
    assignValueCurrency,
    totalAmountComputed,
    totalAmountReceiptComputed,
    totalAmountInvoiceComputed,
  };
};
